import { render, staticRenderFns } from "./wpsa.vue?vue&type=template&id=d3a79cdc&scoped=true"
import script from "./wpsa.vue?vue&type=script&lang=js"
export * from "./wpsa.vue?vue&type=script&lang=js"
import style0 from "./wpsa.vue?vue&type=style&index=0&id=d3a79cdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../Retirement Planner.Admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a79cdc",
  null
  
)

export default component.exports